import axios from 'axios';

const req = axios.create({
  baseURL: process.env.REACT_APP_HOST,
  headers: {
    'Content-Type': 'application/json',
  },
});

export { req };
